import React, {useContext} from "react";
import "./Pubs.scss";
import PubCard from "../../components/pubCard/PubCard";
import {pubSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function Pubs() {
  const {isDark} = useContext(StyleContext);
  if (!pubSection.display) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="pubs">
        <div className="pub-header">
          <h1 className="pub-header-title">{pubSection.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode pub-header-subtitle"
                : "subTitle pub-header-subtitle"
            }
          >
            {pubSection.subtitle}
          </p>
          {pubSection.pubs.map((pub, i) => {
            return (
              <PubCard
                key={i}
                pubDetails={{
                  title: pub.title,
                  subtitle: pub.subtitle,
                  paper_url: pub.paper_url,
                  website_url: pub.website_url,
                  github_url: pub.github_url,
                  image: pub.image,
                  isDark
                }}
              />
            );
          })}
        </div>
      </div>
    </Fade>
  );
}
